import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'apartment',
  standalone: true
})
export class ApartmentPipe implements PipeTransform {

  translate = inject(TranslateService);

  transform(apartment: any, short = false): string {
    if (!apartment ) {
      return '';
    }

    const code = apartment.code ?? '';
    const floor = apartment.floor !== undefined ? `${this.translate.instant('METER.FLOOR')} ${apartment.floor}` : '';
    const apartmentNumber = apartment.number ? `${this.translate.instant('METER.NUMBER')} ${apartment.number}` : '';
    if (short) {
      return `${code} - ${floor}, ${apartmentNumber}`.replace(/\s*,\s*,/g, ',').trim();
    }
    if (!apartment.building) {
      return "";
    }
    const building = apartment.building;
    const city = building.city?.name || '';
    const address = building.address || '';
    const houseNumber = building.houseNumber || '';

    return `${code} - ${address}, ${houseNumber}, ${city} - ${floor}, ${apartmentNumber}`.replace(/\s*,\s*,/g, ',').trim();
  }
}
